export default "__VITE_ASSET__f552c6b3__"